/**
 * Pull UTM parameters from URL and store in local session storage
 * Used to track marketing campaign performance
 * passed to events service
 */
export function storeUTMParams() {
  const utmParams = new URLSearchParams(window.location.search)
  const utmContent = utmParams.get('utm_content')
  const utmMedium = utmParams.get('utm_medium')
  const utmCampaign = utmParams.get('utm_campaign')
  const utmSource = utmParams.get('utm_source')

  if (utmContent) {
    window.sessionStorage.setItem('utm_content', utmContent)
  }
  if (utmMedium) {
    window.sessionStorage.setItem('utm_medium', utmMedium)
  }
  if (utmCampaign) {
    window.sessionStorage.setItem('utm_campaign', utmCampaign)
  }
  if (utmSource) {
    window.sessionStorage.setItem('utm_source', utmSource)
  }
}

/**
 * Get UTM parameters from session storage
 */
export function getUTMFromSessionStorage() {
  return {
    utmContent: window.sessionStorage.getItem('utm_content'),
    utmMedium: window.sessionStorage.getItem('utm_medium'),
    utmCampaign: window.sessionStorage.getItem('utm_campaign'),
    utmSource: window.sessionStorage.getItem('utm_source'),
  }
}
